import { createSelector } from 'redux-orm';

import orm from '../orm';

export const makeCategoryByIdSelector = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ Category }, id) => {
      const categoryModel = Category.withId(id);

      if (!categoryModel) {
        return categoryModel;
      }

      return categoryModel.ref;
    },
  );

export const categoryByIdSelector = makeCategoryByIdSelector();
